import React from 'react';
import { Link } from 'react-router-dom';
import { ONE_LINER, SUBSTACK_URL, LINKEDIN_URL, CONTACT_MAILTO } from './ui';

/**
 * Footer, version 2. The mark, the one-liner, the outside links, the six
 * page links, copyright, New Albany. No ticker.
 */

const PAGE_LINKS = [
  { to: '/why-it-matters',       label: 'Why it matters' },
  { to: '/compass',            label: 'The CoThink Compass' },
  { to: '/what-we-do',        label: 'What we do' },
  { to: '/frameworks',         label: 'Frameworks' },
  { to: '/what-we-think', label: 'What we think' },
  { to: '/book',               label: 'The book' },
  { to: '/who-we-are',       label: 'Who we are' },
];

const Footer = () => (
  <footer className="bg-white dark:bg-navy-850 border-t border-navy-200 dark:border-navy-700">
    <div className="mx-auto max-w-page px-5 md:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <img src="/rbl-mark.svg" alt="" width="28" height="28" className="h-7 w-7" />
            <span className="font-sans font-semibold text-[17px] text-navy-800 dark:text-white">Right Brain Labs</span>
          </div>
          <p className="font-sans text-interface mt-4 max-w-[44ch] text-navy-600 dark:text-[#C9D2E0]">{ONE_LINER}</p>
          <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 font-sans text-interface font-medium">
            <a href={SUBSTACK_URL} target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-500 dark:text-emerald-300">Substack</a>
            <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-500 dark:text-emerald-300">LinkedIn</a>
            <a href={CONTACT_MAILTO} className="text-emerald-600 hover:text-emerald-500 dark:text-emerald-300">Start a conversation</a>
          </div>
        </div>
        <div className="md:col-span-6">
          <div className="font-sans text-eyebrow uppercase font-semibold text-navy-500 dark:text-navy-400 mb-3">Pages</div>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
            {PAGE_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="font-sans text-small text-navy-800 hover:text-emerald-600 dark:text-white dark:hover:text-emerald-300 min-h-[32px] inline-flex items-center">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-navy-200 dark:border-navy-700 flex flex-col sm:flex-row justify-between gap-2 font-sans text-small text-navy-500 dark:text-navy-400">
        <span>&copy; 2026 Right Brain Labs LLC. All rights reserved.</span>
        <span>New Albany, Ohio. Founded September 29, 2025. <Link to="/privacy" className="hover:text-emerald-600 dark:hover:text-emerald-300 underline">Privacy</Link></span>
      </div>
    </div>
  </footer>
);

export default Footer;
